/* tslint:disable */

declare var Object: any;
export interface SFOnDutyInterface {
  "id"?: number;
}

export class SFOnDuty implements SFOnDutyInterface {
  "id": number;
  constructor(data?: SFOnDutyInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFOnDuty`.
   */
  public static getModelName() {
    return "SFOnDuty";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFOnDuty for dynamic purposes.
  **/
  public static factory(data: SFOnDutyInterface): SFOnDuty{
    return new SFOnDuty(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFOnDuty',
      plural: 'SFOnDuties',
      path: 'SFOnDuties',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFOnDuty.ts